export default __webpack_public_path__ + "static/media/miezeProfileTrans.c4b4ebe0.png";